import { defineStore } from 'pinia';
import { useApi } from '@/lib/api';
import { useGlobalStore } from './global-store-base';
import { useUser } from './user';

export const usePlacementNames = defineStore('placement-names', () => {
  const api = useApi();
  const globalStoreBase = useGlobalStore({
    load: api.placementName_GetPlacementNames,
    dto: 'PlacementNameDto',
    create: api.placementName_Create,
    update: api.placementName_Update,
    delete: api.placementName_Delete,
    usage: api.placementName_GetUsage,
    signalR: 'PlacementNameUpdate',
  });

  async function replace(id: number, replacementId: number) {
    await api.placementName_Replace(useUser().brandId, id, { replacementId });
    await globalStoreBase.loadAll();
  }

  async function setDefaultTags(id: number, tagIds: number[]) {
    const updated = await api.placementName_SetDefaultTags(useUser().brandId, id, { tagIds });
    const index = globalStoreBase.loaded.value.findIndex((i) => i.id === updated.id);
    if (index > -1) globalStoreBase.loaded.value[index] = updated;
  }

  return { ...globalStoreBase, replace, setDefaultTags };
});
